// reducers/baselineMarketDetailsReducer.js
import {
  SUBMIT_BASELINE_MARKET_DETAILS_REQUEST,
  SUBMIT_BASELINE_MARKET_DETAILS_SUCCESS,
  SUBMIT_BASELINE_MARKET_DETAILS_FAILURE,
} from "../actions/baselineMarketDetailsActions";

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const baselineMarketDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_BASELINE_MARKET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null,
      };
    case SUBMIT_BASELINE_MARKET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
        errorMessage: null,
      };
    case SUBMIT_BASELINE_MARKET_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default baselineMarketDetailsReducer;
